module.exports = __webpack_public_path__ + "static/media/HourOfCode.6e2871b5.png";